/**
 * A catalog fix step that is one of several alternatives rather than a step
 * in a sequence, e.g. the Do Not Sell card's
 * "Option A (GPC Exemption - Zero-Code if GPC is active): Honor …".
 * The card letters these instead of numbering them, so readers do not try to
 * do all four. Only the catalog's own words are used, split at " - ".
 */
export interface FixOption {
  letter: string;
  name: string;
  qualifier?: string;
  text: string;
}

const OPTION = /^Option ([A-Z]) \(([^)]+)\):\s*([\s\S]+)$/;

export function parseFixOption(step: string): FixOption | null {
  const match = OPTION.exec(step.trim());
  if (!match) return null;
  const [, letter, heading, text] = match;
  const [name, ...rest] = heading.split(' - ');
  return { letter, name: name.trim(), qualifier: rest.length ? rest.join(' - ').trim() : undefined, text: text.trim() };
}

/** Plain steps keep their catalog order; option steps are collected after them. */
export function splitFixSteps(steps: readonly string[]): { steps: string[]; options: FixOption[] } {
  const plain: string[] = [];
  const options: FixOption[] = [];
  for (const step of steps) {
    const option = parseFixOption(step);
    if (option) options.push(option);
    else plain.push(step);
  }
  return { steps: plain, options };
}
